import { ConferenceOptions, Reservation } from "twilio-taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { getReservationsByTask, isCallTask, sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { CbmImpl } from "~/modules/cbm/CbmImpl";
import { Action } from "~/modules/actions/Action";



export interface AcceptTaskOptions {
    conferenceOptions?: ConferenceOptions;
}



















export class AcceptTask implements Action<Promise<Reservation>> {
    


    #taskSid: string;

    


    #acceptTaskOptions?: AcceptTaskOptions;

    constructor(taskSid: string, acceptTaskOptions?: AcceptTaskOptions) {
        this.#taskSid = taskSid;
        this.#acceptTaskOptions = acceptTaskOptions;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.getInstanceOf(TaskRouterImpl);
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.getInstanceOf(AnalyticsImpl);
        const cbm = context.getInstanceOf(CbmImpl);

        logger.debug(`acceptTask invoked with taskSid: ${this.#taskSid}`);

        const conferenceOptions = this.#acceptTaskOptions?.conferenceOptions;

        if (!worker) {
            const errorMsg = "acceptTask: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "pending");

        if (!reservation) {
            const errorMsg = `acceptTask: Reservation for task ${this.#taskSid} not found`;

            sendTrackingEvent(EVENTS.AcceptTaskCompleted, analytics, worker, errorMsg);

            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        if (!isCallTask(reservation.task)) {
            if (!cbm) {
                const errorMsg = "acceptTask: CBM SDK is not initialized";
                logger.error(errorMsg);
                sendTrackingEvent(EVENTS.AcceptTaskCompleted, analytics, worker, errorMsg);
                return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
            }

            try {
                const createdReservation = await cbm.acceptReservation(reservation);
                sendTrackingEvent(EVENTS.AcceptTaskCompleted, analytics, worker);
                return createdReservation;
            } catch (error) {
                const errorMsg = `acceptTask: Failed to accept reservation ${reservation.sid}`;
                logger.error(errorMsg);
                return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
            }
        }
        try {
            await reservation.conference(conferenceOptions);

            sendTrackingEvent(EVENTS.AcceptTaskCompleted, analytics, worker);

            return reservation;
        } catch (e) {
            const errorMsg = `acceptTask: Failed to create conference for ${reservation.sid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.AcceptTaskCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
